<script>
    //import {Link} from './router';
    import app from "./stores/app";
    import user from './stores/user';
    import {SENT_VIA} from './lib/constants';
    import {createEventDispatcher} from 'svelte';
    import {convertDate} from './lib/lib';

    export let message;

    let sentDate;
    let scheduleDate;

    const dispatch = createEventDispatcher();

    const cancelClick = () => {
        dispatch('cancel', {
            id: message.id,
        });
    }

    const clockClick = () => {
        dispatch('block', {id: message.id});
    }

    const unblockClick = () => {
        dispatch('unblock', {id: message.id});
    }

    $: {
        sentDate = convertDate(message.date_sent)
        scheduleDate = convertDate(message.scheduledon)
    }
</script>

<tr>
    {#if $user.is_admin && $app.device !== 'xs'}
        <td>{ message.id }</td>
    {/if}
    <td class="row-header">
        { sentDate }
    </td>
    {#if $user.is_admin}
        <td class="data"><span class="caption">Λογαριασμός:</span><span class="value">{ message.username }</span></td>
    {/if}
    <td class="originator">
        { message.originator }
    </td>
    <td class="message">
        { message.sms }
    </td>
    <td class="data">
        <span class="caption">Προγραμματισμός:</span><span class="value">{ scheduleDate }</span>
    </td>
    <td class="data text-right">
        <span class="caption">Παραλήπτες:</span><span class="value">{ message.total_recipients }</span>
    </td>
    {#if $user.is_admin}
        <td class="data"><span class="caption" title="Από">Από:</span><span class="value">{ SENT_VIA[message.sent_via] }</span></td>
    {/if}
    <td class="data last text-center">
        {#if message.is_bad == 1}<i class="fa fa-warning" title="Μη έγκυρο μήνυμα. Η αποστολή του ακυρώθηκε."></i>{/if}
    </td>
    <td class="row-actions">
        {#if message.is_blocked == 1}
            <span title="Λήξη διακοπής" on:click="{ unblockClick }"><i class="fa fa-play"></i></span>
        {:else}
            <span title="Διακοπή αποστολής" on:click="{ clockClick }"><i class="fa fa-pause"></i></span>
        {/if}
        <span class="delete" title="Ακύρωση αποστολής" on:click="{ cancelClick }"><i class="fa fa-trash-o"></i></span>
    </td>
</tr>